import { FC } from "react";
import { Box, SvgIcon } from "@mui/material";

import { useAsu } from "@framework/provider-asu";

import LogoImg from "../../../../../assets/logo.svg";
import LogoTextImg from "../../../../../assets/logo-text.svg";

export const Logo: FC = () => {
  const { isMenuOpen } = useAsu();
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: 56 }}>
      <SvgIcon sx={{ width: 32, height: 32 }} viewBox="0 0 32 32">
        <LogoImg />
      </SvgIcon>
      {isMenuOpen ? (
        <SvgIcon sx={{ width: 169, height: 21, ml: 1 }} viewBox="0 0 169 21">
          <LogoTextImg />
        </SvgIcon>
      ) : null}
    </Box>
  );
};
